import { fetchTailorMadeTour } from 'actions/tour/TourV2Actions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

function useTailorMadeTour() {
  const dispatch = useAppDispatch()
  const tailorMadeTour = useAppSelector((state) => state.tour.tailorMadeTour)
  useEffect(() => {
    dispatch(fetchTailorMadeTour())
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return tailorMadeTour
}

export default useTailorMadeTour
